import { render, staticRenderFns } from "./ManualBoxImg.vue?vue&type=template&id=19674418&scoped=true"
import script from "./ManualBoxImg.vue?vue&type=script&lang=js"
export * from "./ManualBoxImg.vue?vue&type=script&lang=js"
import style0 from "./ManualBoxImg.vue?vue&type=style&index=0&id=19674418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19674418",
  null
  
)

export default component.exports